import dayjs from "dayjs";
import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import type { CalendarState } from "../types";
import { calculateDateRange } from "../utils";

const initialState: CalendarState = {
  drawerIsOpen: false,
  selectedDate: dayjs().format("YYYY-MM-DD"),
  ...calculateDateRange(dayjs().toISOString()),
};

export const calendarSlice = createSlice({
  name: "calendarSlice",
  initialState,
  reducers: {
    updateDateRange(state, action: PayloadAction<string>) {
      const { fromDate, toDate } = calculateDateRange(action.payload);
      state.selectedDate = dayjs(action.payload).format("YYYY-MM-DD");
      state.fromDate = fromDate;
      state.toDate = toDate;
    },
    setSelectedDate(state, action: PayloadAction<string>) {
      state.selectedDate = dayjs(action.payload).format("YYYY-MM-DD");
    },
    openDrawer(state) {
      state.drawerIsOpen = true;
    },
    closeDrawer(state) {
      state.drawerIsOpen = false;
    },
  },
  selectors: {
    selectDateRange: (state) => ({
      fromDate: state.fromDate,
      toDate: state.toDate,
    }),
  },
});

export const { actions: calendarSliceActions, selectors: calendarSliceSelectors } = calendarSlice;
